import { Grid } from "@mui/material";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import setToast from "../../helpers/toaster.helper";
import { LandlineFormData, LandlineSubscriberFormData, PhoneNumberData } from "../../models/add-phone-number.model";
import { PhoneNumberService } from "../../services/PhonenumberService";
import { UserService } from "../../services/UserService";
import { UtilityService } from "../../services/UtilityService";
import { AppRoutes } from "../routes/route.path";
import { ToasterTexts, appNote } from "../shared/constants";
import { ToasterType } from "../shared/toaster/toaster.model";
import TwofactorAuthenticationForm from "../shared/twofactor-authentication-form.component";

interface IProps extends Partial<LandlineFormData>, Partial<LandlineSubscriberFormData> {
    IsTeamsApp?: boolean;
    IsMobileDevice?: boolean;
    IsRehost?: boolean;
    handleStatus?: (data: boolean) => void
    PhoneNumberData?: PhoneNumberData;
    AddressData?: LandlineSubscriberFormData

}

const VoiceVerification = (props: IProps) => {
    const phndata = props.PhoneNumberData
    const AddrData = props.AddressData
    const [otp, setOtp] = useState<string>("");
    const [showLoader, setShowLoader] = useState<boolean>(false);
    const [isValid, setIsValid] = useState<boolean>(true);
    const { state } = useLocation();
    const navigate = useNavigate();
    const location = useLocation();
    const [showResendTimer, setShowResendTimer] = useState<boolean>(!state?.VerificationCount || !phndata.VerificationCount);
    const [error, setError] = useState<string>((state?.VerificationCount || phndata?.VerificationCount) && (state?.VerificationCount || phndata?.VerificationCount) >= 2 ? "You have reached maximum verification attempts" : "");
    const [showErrorMessage, setShowErrorMessage] = useState<boolean>((state?.VerificationCount || phndata?.VerificationCount) && (state?.VerificationCount || phndata?.VerificationCount) >= 2);

    const verifyOtp = (e: any) => {
        e.preventDefault();
        if (otp.length === 5) {
            let data = {
                organizationId: UserService.hasSysAdminRole() ? (state?.Organization?.ID || phndata.organizationId || "") : UserService.getCurrentUserOrgId(),
                name: state?.Name || phndata.Name || "",
                code: otp,
                number: UtilityService.unmaskPhoneNumber(state?.PhoneNumber || phndata.PhoneNumber || ""),
                productType: state?.ProductType || phndata.SelectProduct,
                address: {
                    loaPersonName: `${state?.FirstName || AddrData.FirstName || ""} ${state?.LastName || AddrData.LastName || ""}`.trim(),
                    houseNumber: state?.HouseNumber || AddrData.HouseNumber || "",
                    streetName: state?.Address || AddrData.Address || "",
                    city: state?.City || AddrData.City || "",
                    stateCode: state?.state || AddrData.State || "",
                    zip: state?.ZipCode || AddrData.ZipCode || "",
                    county: state?.Country || AddrData.Country || ""
                }
            };
            setShowLoader(true);
            let promise = props?.IsRehost ? PhoneNumberService.reHostPhoneNumberVerifyVoiceOTP(data) : PhoneNumberService.verifyVoiceOTP(data);
            promise.then((response: any) => {
                if (response.status === 200) {
                    setIsValid(false)
                    setToast(ToasterTexts.VOICE_OTP_VERIFY_SUCCESS, ToasterType.SUCCESS)
                    setShowLoader(false);
                    props.handleStatus(false)
                }
            }).catch((error: any) => {
                setShowLoader(false);
                if (error.response.status === 400 && (error.response.data.code === "INVALIDOTP" || error.response.data.code === "INVALID_OTP")) {
                    setShowResendTimer(false);
                    setToast(ToasterTexts.INVAILD_VOICE_OTP, ToasterType.DANGER);
                    setShowErrorMessage((state?.VerificationCount || phndata.VerificationCount) && (state?.VerificationCount || phndata.VerificationCount) >= 2);
                    setError((state?.VerificationCount || phndata.VerificationCount) && (state?.VerificationCount || phndata.VerificationCount) >= 2 ? "You have reached maximum verification attempts" : "");
                    setTimeout(() => navigate(location.pathname, { state: { ...location.state, VerificationCount: (state?.VerificationCount || phndata.VerificationCount || 0) + 1 }, replace: true }), 0);
                }
                else if (error.response.status === 500) {
                    setShowErrorMessage(true)
                }
            })
        }
    };

    const resendOtp = (e?: any) => {
        e?.preventDefault();

        let data = {
            organizationId: UserService.hasSysAdminRole() ? (state?.Organization?.ID || phndata?.organizationId || "") : UserService.getCurrentUserOrgId(),
            name: state?.Name || phndata?.Name || "",
            code: "",
            number: UtilityService.unmaskPhoneNumber(state?.PhoneNumber || phndata?.PhoneNumber),
            productType: state?.ProductType || phndata?.SelectProduct,
            address: {
                loaPersonName: `${state?.FirstName || AddrData.FirstName || ""} ${state?.LastName || AddrData.LastName || ""}`.trim(),
                houseNumber: state?.HouseNumber || AddrData.HouseNumber || "",
                streetName: state?.Address || AddrData.Address || "",
                city: state?.City || AddrData.City || "",
                stateCode: state?.state || AddrData.State || "",
                zip: state?.ZipCode || AddrData.ZipCode || "",
                county: state?.Country || AddrData.Country || ""
            }
        };
        setToast(ToasterTexts.RESENDING_VOICE_OTP, ToasterType.INFO);
        let promise = props.IsRehost ? PhoneNumberService.reHostPhoneNumberSendVoiceOTP(data) : PhoneNumberService.sendVoiceOTP(data);
        promise.then((response: any) => {
            if (response.status === 200) {
                setToast(ToasterTexts.RESEND_VOICE_OTP_SUCCESS, ToasterType.SUCCESS)
                setTimeout(() => navigate(location.pathname, { state: { ...location.state, VerificationCount: 0 }, replace: true }), 0);
            }
        }).catch(() => {
            setToast(ToasterTexts.RESEND_VOICE_OTP_FAILURE, ToasterType.DANGER)
        })
    }
    const getHomeLink = () => {
        if (state?.IsSignUp) {
            return AppRoutes.SIGN_UP;
        }
        return UserService.hasSysAdminRole() ? AppRoutes.PHONE_NUMBERS : AppRoutes.PLANS;
    }
    return <Grid container className={`${props.IsMobileDevice ? 'paper-background br-2 add-phone-number-paper-border' : ''} t-align-center`}>
        <TwofactorAuthenticationForm
            IsLoading={showLoader}
            StepLength={1}
            NumOfSteps={5}
            IsNumberInput={true}
            HandleOnChangeStepValue={setOtp}
            Value={otp}
            ErrorMessage={error}
            ResendOtp={resendOtp}
            VerifyOtp={verifyOtp}
            IsValid={showErrorMessage ? false : isValid}
            ShowResendTimer={showResendTimer}
            ResendTime={30}
            ResendLabel={"Call again"}
            Title={`Enter the OTP received via call on ****** ${(state?.PhoneNumber || phndata?.PhoneNumber)?.slice((state?.PhoneNumber || phndata?.PhoneNumber).length - 4)}`}
            // IsPlans={true}
            WrongAttemptsDisplayMsg={appNote.ADD_PHONE_NUMBER_VOICE_OTP_ERROR}
            WrongAttemptsBtnLabel={showErrorMessage ? state?.IsSignUp ? "Go to Sign-Up" : `Go to ${UserService.hasSysAdminRole() ? "Phone numbers" : "Plans"}` : ""}
            WrongAttemptsBtnPath={getHomeLink()}
            OtpTextFieldColor={"bg-color-auth-field"}
            IsUnAuthScreen={true}
        />
    </Grid>
}
export default VoiceVerification;